var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBosta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3897 5.25389L10.5634 0.158497C10.2113 -0.0528324 9.76526 -0.0528324 9.41315 0.158497L0.586855 5.25389C0.234742 5.46522 0 5.84091 0 6.26357V13.7306C0 14.1532 0.211268 14.5289 0.586855 14.7402L9.41315 19.8356C9.60094 19.9296 9.78874 20 10 20C10.2113 20 10.3991 19.953 10.5869 19.8356L19.4131 14.7402C19.7653 14.5289 20 14.1532 20 13.7306V6.26357C19.9765 5.84091 19.7418 5.46522 19.3897 5.25389ZM17.9343 11.8756L14.6714 9.99707L17.9343 8.11858V11.8756ZM10 2.17787L17.0657 6.26357L10 10.3493L2.9108 6.26357L10 2.17787ZM2.04225 8.0951L5.30517 9.97359L2.04225 11.8521V8.0951ZM10 17.7928L2.9108 13.7071L7.32394 11.1476L9.38967 12.3452C9.57747 12.4391 9.76526 12.5095 9.97653 12.5095C10.1878 12.5095 10.3756 12.4626 10.5634 12.3452L12.6291 11.1476L17.0423 13.7071L10 17.7928Z",
    fill: "#E30613"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBosta);
export default __webpack_public_path__ + "9637ba53b22df5ec68fd22d6004485d0.svg";
export { ForwardRef as ReactComponent };